import { render, staticRenderFns } from "./EditResultsModal_v2.vue?vue&type=template&id=525011b8&scoped=true&"
import script from "./EditResultsModal_v2.vue?vue&type=script&lang=js&"
export * from "./EditResultsModal_v2.vue?vue&type=script&lang=js&"
import style0 from "./EditResultsModal_v2.vue?vue&type=style&index=0&id=525011b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525011b8",
  null
  
)

export default component.exports